import { Injectable } from '@angular/core';

export type AppLanguage = 'en' | 'ar';

/** Primary key per product spec; kept in sync with legacy `app_language` for GraphQL. */
const STORAGE_KEY_LOCALE = 'locale';
const STORAGE_KEY_LEGACY = 'app_language';
const RTL_LANGUAGES: AppLanguage[] = ['ar'];

function readStoredLanguage(): AppLanguage {
    if (typeof window === 'undefined') return 'en';
    const raw =
        localStorage.getItem(STORAGE_KEY_LOCALE) ||
        localStorage.getItem(STORAGE_KEY_LEGACY) ||
        'en';
    return raw === 'ar' ? 'ar' : 'en';
}

@Injectable({
    providedIn: 'root',
})
export class LanguageService {

    get currentLanguage(): AppLanguage {
        return readStoredLanguage();
    }

    get isRtl(): boolean {
        return RTL_LANGUAGES.includes(this.currentLanguage);
    }

    initLanguage(): void {
        if (typeof document === 'undefined') return;
        if (typeof window !== 'undefined') {
            const legacy = localStorage.getItem(STORAGE_KEY_LEGACY);
            if (legacy && !localStorage.getItem(STORAGE_KEY_LOCALE)) {
                localStorage.setItem(STORAGE_KEY_LOCALE, legacy === 'ar' ? 'ar' : 'en');
            }
        }
        document.documentElement.dir = this.isRtl ? 'rtl' : 'ltr';
        document.documentElement.lang = this.currentLanguage;
    }

    setLanguage(lang: AppLanguage): void {
        if (typeof window === 'undefined') return;
        const current = readStoredLanguage();
        if (lang === current) return;
        localStorage.setItem(STORAGE_KEY_LOCALE, lang);
        localStorage.setItem(STORAGE_KEY_LEGACY, lang);
        window.location.reload();
    }
}
